export default "__VITE_ASSET__79bcef22__"